import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const settingsRoutes: Routes = [
  {
    path: "system-settings",
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.SETTINGS.SYSTEM_SETTINGS,
        TRANSLATION_PATHS.AUTHENTICATION.ROLES,
        TRANSLATION_PATHS.AUTHENTICATION.USERS,
      ]),
    },
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.SYSTEM_SETTINGS.VIEW },
    loadChildren: () => import("./domains/system-settings/system-settings.routes").then(m => m.systemSettingsRoutes),
  },
];
